<app-header [showCart]="false"></app-header>
<div class="page" [ngClass.gt-sm]="{ 'desktop': true }">
    <div class="confirmation" fxLayout="column" fxLayoutAlign="center center">
        <h2 class="mat-h2">{{ 'CONFIRMATION.TITLE_ORDER_SENT' | translate }}</h2>
        <!-- <p class="confirm-text1">{{ 'CONFIRMATION.TEXT_ORDER_SENT_1' | translate }}</p> -->
        <!-- <p class="confirm-text2">{{ 'CONFIRMATION.TEXT_ORDER_SENT_2' | translate }}</p> -->
        <p class="confirm-label">{{ 'CONFIRMATION.LABEL_ORDER_ID' | translate }}:<br> {{ id }}</p>
        <!-- TODO: viewing existing orders was removed from scope -->
        <!-- <a mat-button [routerLink]="['/order', id]" color="primary" class="confirm-summary">{{ 'CONFIRMATION.ACTION_VIEW_ORDER' | translate }}</a> -->
        <button mat-button class="confirm-button large" routerLink="/terminals">{{ 'CONFIRMATION.ACTION_NEW_ORDER' | translate }}</button>
    </div>
</div>
